export default function FooterCompact() {
  return (
    <footer className="bg-[#1B1E3E]/60 backdrop-blur-sm text-white py-4 px-4 sm:px-6 border-t border-white/10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="text-white/60 text-xs text-center md:text-left">
            © 2025 ASTRAMINER. All rights reserved.
          </p>
          <div className="flex gap-4 text-xs text-white/50">
            <a href="mailto:support@astrauniv.com" className="hover:text-white/80 transition-colors">
              support@astrauniv.com
            </a>
            <span className="text-white/30">|</span>
            <a href="tel:+91 7869941174" className="hover:text-white/80 transition-colors">
              +91 7869941174
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
